import * as React from "react"
import { Link } from "gatsby"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import logo from "../images/scyrg-4.png";
import logoWhite from "../images/scyrg-white.png";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import * as classes from './header.module.css';

const Header = () => {
  return (
    <div>
        <Container fluid style={headerContainer}>
            <Row className="d-none d-sm-block">
                <Col style={logoContainer}>
                    <Link to="/">
                        <Image src={logo} alt="Southern California Yacht Racing Group Logo" fluid style={logoStyle} />
                    </Link>
                </Col>
            </Row>
            <Row style={navBarStyle}>
                <Navbar collapseOnSelect expand="lg" bg="" variant="dark">
                <Container>
                <Navbar.Brand href="#home" className="d-block d-sm-none">
                    <Link to="/">
                        <Image src={logoWhite} alt="Southern California Yacht Racing Group Logo" fluid style={logoStyleMobile}/>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ml-auto align-content-center" style={{width:"100%",justifyContent:"center"}}>
                        <Link to="/" className={"nav-link "+classes.navLink}>Home</Link>
                        <Link to="/calendar" className={"nav-link "+classes.navLink}>Calendar</Link>
                        <Link to="/results" className={"nav-link "+classes.navLink}>Past Results</Link>
                        <Link to="/tracking" className={"nav-link "+classes.navLink}>Race Tracking</Link>
                        <Link to="/afterrace" className={"nav-link "+classes.navLink}>After Race Events</Link>
                        <Link to="/photos" className={"nav-link "+classes.navLink}>Photos</Link>
                        <Link to="/sponsors" className={"nav-link "+classes.navLink}>Sponsors</Link>
                        <Link to="/charities" className={"nav-link "+classes.navLink}>Charities</Link>
                        <Link to="/orrora" className={"nav-link "+classes.navLink}>ORR/ORA Explained</Link>
                        <Link to="/contact" className={"nav-link "+classes.navLink}>Contact Us</Link>
                    </Nav>
                </Navbar.Collapse>
                </Container>
                </Navbar>
            </Row>
        </Container>
    </div>
  )
}

export default Header

const logoContainer = {
    textAlign: "center"
}

const logoStyle = {
    maxHeight: "170px",
}

const logoStyleMobile = {
    width:"60vw"
}

const navBarStyle = {
    backgroundColor: "#093751"
}

const headerContainer = {
    marginBottom: "30px"
}